import React from 'react';
import { CaretDown, CaretUp } from '@phosphor-icons/react';
import classNames from 'classnames';

import { Button } from '../../components/general';

import { getThumbnailSize } from '../video/getVideoContainerData';

interface Props {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  isPortrait: boolean;
  isBig?: boolean;
  customWidth?: string;
}

const ViewAllBtn: React.FC<Props> = (props) => {
  const { isCollapsed, setIsCollapsed, isPortrait, isBig, customWidth } = props;

  const { thumbWidth, thumbAspect } = getThumbnailSize(isPortrait, isBig);

  return (
    <Button
      onClick={() => setIsCollapsed(!isCollapsed)}
      variant="custom"
      colour="grey-outline-salmon"
      className={classNames(
        'h-min flex flex-col items-center justify-center text-sm rounded-md',
        customWidth ?? thumbWidth,
        thumbAspect,
      )}
    >
      {isCollapsed ? (
        <React.Fragment>
          <CaretDown size={24} />
          <div>View All</div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <CaretUp size={24} />
          <div>View Less</div>
        </React.Fragment>
      )}
    </Button>
  );
};

export default ViewAllBtn;
